import { MLHelper, IDictionary, isNullOrUndefined } from '@bimser/core';

export class MultiLanguageText {
	__ML_CLASS_OBJECT__ = true;

	__data: IDictionary<string> = {};
	private __onChange: (text: string, culture: string, existCultures: string[]) => void;

	[key: string]: any; // Index signature

	/**
	 *  * Example onChange parameter --> (text: string, culture: string, existCultures: string[]) => { this.__onChangeMLTextValue(text, 'text', culture, existCultures) }
	 */
	constructor(
		onChange?: (text: string, culture: string, existCultures: string[]) => void,
		text?: string,
		culture?: string
	) {
		this.__onChange = onChange;
		if (text && culture) {
			this.setText(text, culture);
		}
		return proxyCreator(this, this.setter.bind(this));
	}

	/**
	 * * Proxy içerisinde mevcut scope' un (this/class' ın) tamamı bulundugu için
	 * herhangi değer değişikliğinde setter tetiklenecek bu yüzden yanlızca bir değerin target' a
	 * atanması sağlıklı olacaktır.
	 */
	private setter(target: MultiLanguageText, value: string, key: string) {
		if ((target as any)[key] !== value) {
			(target as any)[key] = value;
		}
	}

	updateTextData(culture: string, text: string) {
		if ((this as any)[culture] !== text) {
			this.__data = { ...this.__data, [culture]: text };
			(this as any)[culture] = text;
			if (
				MLHelper.supportedLanguages.find(lang => lang.culture === culture) &&
				this.__onChange
			) {
				this.__onChange(text, culture, Object.keys({ ...this.__data, [culture]: text }));
			}
		}
	}

	getText(culture?: string) {
		const eng = 'en-US';
		let d = this.__data[culture || MLHelper.currentLanguage.culture];

		if (isNullOrUndefined(d) || d === '') {
			d = this.__data[MLHelper.defaultLanguage.culture];
			if (isNullOrUndefined(d) || d === '') {
				if (this.__data[eng]?.length) {
					d = this.__data[eng];
				} else {
					const keys = Object.keys(this.__data);
					for (const lang of keys) {
						if (this.__data[lang]?.length) {
							d = this.__data[lang];
						}
					}
				}
			}
		}

		return d || '';
	}

	setText(text: string, culture?: string) {
		culture = culture || MLHelper.currentLanguage.culture;
		this.updateTextData(culture, text);
	}

	removeText(culture?: string) {
		culture = culture || MLHelper.currentLanguage.culture;
		this.updateTextData(culture, undefined);
	}

	removeAll() {
		Object.keys(this.__data).forEach(culture => {
			this.updateTextData(culture, undefined);
		});
	}

	getData() {
		return this.__data;
	}

	setData(data: IDictionary<string> | MultiLanguageText) {
		const _data =
			typeof data?.getData === 'function' ? data.getData() : Object.assign({}, data || {});

		this.__data = _data;

		Object.keys(data).forEach(culture => (this[culture] = data[culture]));
	}
}

function proxyCreator<MultiLanguageText>(
	obj: MultiLanguageText,
	setter: (target: MultiLanguageText, value: any, name: string) => void
): MultiLanguageText {
	const handler: ProxyHandler<any> = {
		get(target: any, key: string) {
			return target[key];
		},
		set(target, key: string, value) {
			setter(target, value, key);
			return true;
		}
	};

	return new Proxy(obj, handler);
}
